export default __webpack_public_path__ + "static/media/schema.e4688ad8.graphql";